module.exports = __webpack_public_path__ + "static/media/filter-close.5f0bdea0.svg";